import { gateway } from '../../../gateway';
import { FlowTask } from '../interfaces/flowTask.interface';

/**
 * Action to update an existing todo task
 *
 * Backend endpoint: PATCH /todo-tasks/self/:taskUid
 * Request body: {
 *   kanbanCategoryUid?: string,
 *   title?: string,
 *   description?: string,
 *   status?: TaskStatus,
 *   priority?: TaskPriority,
 *   deadline?: string
 * }
 * Response: { status: 200, message: "Todo task updated", data: FlowTask }
 */
export const updateTodoTaskAction = async (
  taskId: string,
  updates: Partial<FlowTask>
): Promise<FlowTask> => {
  try {
    if (!taskId) {
      throw new Error('Task ID is required');
    }

    const updatePayload: any = {};

    // NEW: move between columns by setting kanbanCategoryUid
    if ((updates as any).kanbanCategoryUid !== undefined) {
      updatePayload.kanbanCategoryUid = (updates as any).kanbanCategoryUid;
    }

    if (updates.name !== undefined) {
      const trimmed = updates.name?.trim?.() ?? '';
      updatePayload.name = trimmed;
    }

    if (updates.description !== undefined) {
      updatePayload.description = updates.description || undefined;
    }

    if (updates.status !== undefined) {
      updatePayload.status = updates.status;
    }

    if (updates.priority !== undefined) {
      updatePayload.priority = updates.priority;
    }

    if (updates.deadline !== undefined) {
      updatePayload.deadline = updates.deadline || undefined;
    }

    const response = await gateway.patch(`/todo-tasks/self/${taskId}`, updatePayload);

    const updatedTask = response.data?.data || response.data;
    if (!updatedTask) {
      throw new Error('Invalid response from server');
    }

    return updatedTask;
  } catch (error: any) {
    console.error('Error updating todo task:', error);
    const errorMessage =
      error?.response?.data?.message || error?.message || 'Failed to update todo task';
    throw new Error(errorMessage);
  }
};
